import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";

export type DeleteOptimizationParams = {
  id: string;
};

export type DeleteOptimizationResponse = {
  success: boolean;
  message: string;
};

export const deleteOptimization = async (data: DeleteOptimizationParams) => {
  const response = await axios.delete<DeleteOptimizationResponse>(`/resume-optimizer/optimization/${data.id}`);
  return response.data;
};

export const useDeleteOptimization = () => {
  const queryClient = useQueryClient();

  const {
    error,
    isPending: loading,
    mutateAsync: deleteOptimizationFn,
  } = useMutation({
    mutationFn: deleteOptimization,
    onSuccess: (_, variables) => {
      // Invalidate optimization data after deletion
      queryClient.invalidateQueries({ queryKey: ["resume-optimizer", "optimization", variables.id] });
    },
  });

  return { deleteOptimization: deleteOptimizationFn, loading, error };
}; 